module.exports = __webpack_public_path__ + "static/media/icon-star-rating.3021d6e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/icon-star-rating.svg
// module id = 645
// module chunks = 6